import { createFetchApi, FetchMiddlewares } from '@backstage/core-app-api';
import {
  ApiBlueprint,
  configApiRef,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  githubAuthApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import { githubTokenMiddleware } from './githubToken';

/**
 * Replaces the app's default fetch API (`api:app/fetch`) with the same
 * middleware plus `githubTokenMiddleware`, so every plugin's reads and writes
 * through the proxy carry the user's GitHub token.
 */
export const fetchModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ApiBlueprint.make({
      name: 'fetch',
      params: defineParams =>
        defineParams({
          api: fetchApiRef,
          deps: {
            configApi: configApiRef,
            identityApi: identityApiRef,
            discoveryApi: discoveryApiRef,
            githubAuthApi: githubAuthApiRef,
          },
          factory: ({ configApi, identityApi, discoveryApi, githubAuthApi }) =>
            createFetchApi({
              middleware: [
                FetchMiddlewares.resolvePluginProtocol({ discoveryApi }),
                FetchMiddlewares.injectIdentityAuth({
                  identityApi,
                  config: configApi,
                }),
                githubTokenMiddleware({
                  discoveryApi,
                  githubAuthApi,
                  authEnvironment:
                    configApi.getOptionalString('auth.environment') ??
                    'development',
                }),
              ],
            }),
        }),
    }),
  ],
});
